import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'antd';
import { FormattedMessage } from 'react-intl';

import './style.less';

const LoadMoreSummary = ({ onClick, columnsCount }) => (
  <Table.Summary.Row>
    <Table.Summary.Cell
      colSpan={columnsCount}
      align="center"
      className="load-more-table-cell"
    >
      <Button onClick={onClick}>
        <FormattedMessage id="commons.table.loadMore" />
      </Button>
    </Table.Summary.Cell>
  </Table.Summary.Row>
);

LoadMoreSummary.propTypes = {
  onClick: PropTypes.func.isRequired,
  columnsCount: PropTypes.number.isRequired,
};

export default LoadMoreSummary;
